export const MenuItems = [
  {
    title: "Swap",
    url: "/swap",
    cName: "nav-links",
  },
  {
    title: "Liquidity",
    url: "/liquidity",
    cName: "nav-links",
  },
];

export const DropdownMenu = [
  {
    title: "Staking Pools",
    url: "/staking-pools",
    cName: "nav-links",
  },
  {
    title: "Staking Farms",
    url: "/staking-farms",
    cName: "nav-links",
  },
  {
    title: "Invest",
    url: "/invest",
    cName: "nav-links",
  },
  {
    title: "NFT Pools",
    url: "/nft-pools",
    cName: "nav-links",
  },
  {
    title: "Lottery",
    url: "/lottery",
    cName: "nav-links",
  },
  {
    title: "Bridge",
    url: "/bridge",
    cName: "nav-links",
  },
];

export const AdminDropdownMenu = [
  {
    title: "Update Stack Pools",
    url: "/update-staking-pool",
    cName: "nav-links",
  },
];

export const PartnerDropdownMenu = [
  {
    title: "Withdraw LP Tokens",
    url: "/withdarw-lp-tokens",
    cName: "nav-links",
  },
];
